export function BenchPreview(): JSX.Element {
  return (
    <div className="appearance-preview preview-bench">
      <i />
      <div>
        <b />
        <section>
          <span />
          <span />
        </section>
      </div>
    </div>
  );
}
